<script>
/**
 * zeluslugi.ru
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */

import VueSlider from 'vue-slider-component';
import CalcTooltip from './CalcTooltip';

const defaultSliderOptions = {
    height        : 10,
    dotSize       : 28,
    speed         : 0.1,
    piecewiseLabel: true,
    realTime      : true,
};

export default {
    name: 'calc-slider-control',

    components: {
        VueSlider,
        CalcTooltip,
    },

    props: {
        value   : Number,
        disabled: { type: Boolean, default: false },
        min     : { type: Number, default: 0 },
        max     : { type: Number, default: 100 },
        title   : { type: String, default: '' },
        tooltip : { type: [String, Boolean], default: false },
    },

    data: () => ({
        options: defaultSliderOptions,
    }),

    computed: {
        val: {
            get() {
                if (this.value > this.max) return this.max;
                if (this.value < this.min) return this.min;
                return this.value;
                // return this.value > this.max ? this.max : this.value;
            },
            set(newValue) {
                this.$emit('input', (newValue > this.max ? this.max : +newValue));
            },
        },
    },
};
</script>

<template>
    <div class="calc__group">
        <div class="calc__label" :class="{calc__label_disabled:disabled}">
            <label class="calc__form-label form-label">{{ title }}</label>
            <calc-tooltip
                v-if="tooltip"
                :content="tooltip"
            ></calc-tooltip>
        </div><!-- // .calc__label -->

        <div class="calc__control" style="padding-top: 16px;">
            <vue-slider
                v-model="val"
                v-bind="options"
                :min="min"
                :max="max"
                :disabled="disabled"
            ><span slot="label" slot-scope="{label}">{{ label }}</span>
            </vue-slider>
        </div>
        <div class="calc__inputbox">
            <input class="form-control calc__input" name="stations" type="number"
                v-model.number="val"
                :min="min"
                :max="max"
                :disabled="disabled"
                placeholder=""
            >
        </div>
    </div><!-- // .calc__group -->
</template>
